import React from 'react'
import { Box } from "@mui/material"
import { AppRetailerBlockContainer } from "@components/DataBlocks"

export default function sitesColumn() {

	return [{
		name: "sitesNameFilter",
		label: "Sites",
		options: { display: 'excluded' }
	}, {
		name: "sitesName",
		label: "Sites",
		headerAlign: "left",
		options: {
			filter: false,
			customBodyRowRenderLite: (value, { sameSites }) => <Box
				sx={{
					display: "flex",
					justifyContent: "center",
					alignItems: !!value?.length ? "start" : "center" ,
					flexDirection: "column",
				}}
			>
				{!!value?.length ? <AppRetailerBlockContainer rows={value} /> : sameSites ? "Same sites" : "Any"}
			</Box>,
		}
	}]

}